import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/90 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/0d5a057c-0f37-4ad7-ac1e-9a4e973b64d1.png" 
              alt="James Cleaning Logo" 
              className="h-12 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium cursor-pointer">
              Home
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium cursor-pointer">
              Services
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium cursor-pointer">
              Reviews
            </button>
            <button onClick={() => scrollToSection('booking')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium cursor-pointer">
              Booking
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium cursor-pointer">
              About
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium cursor-pointer">
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('booking')}
            className="bg-teal-600 text-white px-6 py-2.5 rounded-full font-medium hover:bg-teal-700 transition-all hover:shadow-lg hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
          >
            Book Now
          </button>
        </div>
      </div>
    </nav>
  );
}
